import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lexend-deca/600.css';
import '@fontsource/lexend-deca/300.css';

export const globalStyles = {
  typography: {
    body: {
      fontFamily: `Lato,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
      size: '0.875rem'
    },
    heading: {
      fontFamily: `Lexend Deca,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
      letterSpacing: `-0.015em`,
      fontWeight: 600
    }
  },
  header: {
    height: `64px`
  }
};
